import FollowUpDoac from "../../../../src/components/content/FollowUpDoac";
import * as React from 'react';
export default {
  FollowUpDoac,
  React
};